import * as types from '../types/basket';


export function addToBasket(data) {
  return dispatch => {
    return dispatch({
      type: types.BASKET_ADD,
      data: data,
    });
  }
}

export function removeFromCard(data) {
  return dispatch => {
    return dispatch({
      type: types.BASKET_REMOVE_PRODUCT,
      data: data,
    });
  }
}

export function updateBasket(data) {
  return dispatch => {
    return dispatch({
      type: types.BASKET_UPDATE,
      data: data,
    });
  }
}

export function clearBasket() {
  return dispatch => {
    return dispatch({
      type: types.BASKET_CLEAR
    });
  }
}

export function openBasket() {
  return dispatch => {
    return dispatch({
      type: types.OPEN_BASKET
    });
  }
}

export function closeBasket() {
  return dispatch => {
    return dispatch({
      type: types.CLOSE_BASKET
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/basketActions.js